const ZIP_REGEX = /^(\d{5}([-]\d{4})?)$/;
/**
 * Validates that a value is a valid zip code.
 */
export const Validator = {
    name: "zip-code",
    errorMessage: "Entered value is in not valid zip code number.",
    validate: value => ZIP_REGEX.test(`${value}`),
};
